import { Controller } from "@hotwired/stimulus"
import { highlightCodeWithin } from "../lib/syntax_highlighting"

export default class extends Controller {
  connect() {
    this.observer = new MutationObserver(() => highlightCodeWithin(this.element))
    this.observer.observe(this.element, { childList: true, characterData: true, subtree: true })
    highlightCodeWithin(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
